import { UserTagComponent } from "@/global/user-tag.component";
import { UserData } from "@/models/user-data.model";
import { CommonModule } from "@angular/common";
import { Component, Input } from "@angular/core";


@Component({
    selector: 'app-person-column',
    template: `
    <div *ngIf="value">
                <app-user-tag [user]="value"></app-user-tag>
              </div>
    `,
    standalone: true,
    imports: [
        CommonModule,
        UserTagComponent
    ],
    styles: [
        `
        `
    ]
})

export class PersonColumnComponent {
@Input() value: UserData | null = null;
}